export const environment = {
  production: true,
  redirect: true,
  baseUrl: 'http://appdigitiamo.innovactors.it',
  wsBaseUrl: 'https://digitiamo.innovactors.it',
  siteName: 'Digitiamo'
};
export const firebaseConfig = {
  apiKey: 'AIzaSyA11auj4ZDgsOzJoqamp4ufpP6ZnEiAdAA',
  authDomain: 'appdigitiamo.firebaseapp.com',
  projectId: 'appdigitiamo',
  storageBucket: 'appdigitiamo.appspot.com',
  messagingSenderId: '568394784791',
  appId: '1:568394784791:web:d29a9d15bbf9130f81bc52'
};
